import { render, staticRenderFns } from "./AddProduct2Pay.vue?vue&type=template&id=0b25b68b&scoped=true"
import script from "./AddProduct2Pay.vue?vue&type=script&lang=js"
export * from "./AddProduct2Pay.vue?vue&type=script&lang=js"
import style0 from "./AddProduct2Pay.vue?vue&type=style&index=0&id=0b25b68b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25b68b",
  null
  
)

export default component.exports